import * as React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import Navigation from "./navigation";
import "react-toastify/dist/ReactToastify.css";
import "./index.scss";
import "./App.scss";
/*import "./assets/css/style.scss";*/

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Navigation />
        <ToastContainer position="top-right" autoClose={3000} />
      </div>
    </BrowserRouter>
  );
}

export default App;
